export default import.meta.ROLLUP_FILE_URL_28FeQhWG1IHWFgoz7efyLQ